import { IMenuTitleOption } from "../../components/menu-title/logic/menuTitle";
import { SERIES_DATA_OPTION } from "./logic/usePropertyExecutiveSummaryData";
import css from "./styles/css.module.scss";

export const CUSTOM_T12_TEXT = "T12";

export interface IClientBrandingAsset {
    name: string,
    colorPrimary: string,
    colorSecondary: string,
    basePath: string,
    stylingClass?: string,
    bannerLogoSize?: number | null,
    bannerImagePosition?: string | null,
    pdfImagePosition?: string | null,
    footerLogoSize?: number | null,
    pdfLogoSize?: number | null,
    showSignOffPage?: boolean,
}

export interface IClientBrandingAssetBuilt extends IClientBrandingAsset {
    banner?: string | null,
    logo?: string | null,
    logoMini?: string | null,
}

export const OPERATIONAL_MENU_OPTIONS: IMenuTitleOption[] = [
    { label: 'Occupancy', value: SERIES_DATA_OPTION.OCCUPANCY },
    { label: 'Expirations', value: SERIES_DATA_OPTION.EXPIRATIONS },
    { label: 'Renewals', value: SERIES_DATA_OPTION.RENEWALS },
    { label: 'Renewal Ratios', value: SERIES_DATA_OPTION.RENEWAL_RATIOS },
    // { label: 'Renewal Trade Outs', value: SERIES_DATA_OPTION.RENEWAL_TRADEOUTS },
    { label: 'Move Outs', value: SERIES_DATA_OPTION.MOVE_OUTS },
    { label: 'Move Out Ratios', value: SERIES_DATA_OPTION.MOVE_OUTS_RATIOS },
    // { label: 'New Lease Trade Outs', value: SERIES_DATA_OPTION.NEW_LEASE_TRADEOUTS }
    // { label: 'Rents', value: SERIES_DATA_OPTION.MOVE_OUTS_RATIOS },
    { label: 'Net Operating Income', value: SERIES_DATA_OPTION.NOI },
    { label: 'Rental Income', value: SERIES_DATA_OPTION.RENTAL_INCOME },
    { label: 'Total Expenses', value: SERIES_DATA_OPTION.TOTAL_EXPENSE },
    { label: 'Budgeted Market Rents', value: SERIES_DATA_OPTION.BUDGETED_MARKET_RENT },
];

// used to decide which clients get their special tri-color band in the header
// TODO still want a better way to do more complex branding, but it's being done as a hotfix because of time pressure
export const ASSET_LIVING_WORKSPACE_IDS = [
    "6de1678f-59af-49b1-accd-4b76b612a160",
    "7fd7d10d-c460-46f2-a326-416e47616120",
    "fe9bd143-a4d4-43c7-8ade-09d39218d18b",
    "1e877fb1-e02a-45ba-bb9a-85eb5866bc1b",
    "e522c19a-1b16-43dd-9bdf-6c3d3611ec63",
    "0b1f3821-0616-4fed-9ca6-bfa9ecfd8f3c",
    "f832d73c-c19c-4737-8274-643b5fa1333e",
    "28f31480-1d8c-4bf8-8cfb-67ad49b797e9",
]

export const CLIENT_LOGO_ASSET_MAP: { [id: string]: IClientBrandingAsset } = {
    "6de1678f-59af-49b1-accd-4b76b612a160": {
        name: "assetLiving",
        colorPrimary: "#003C71",
        colorSecondary: "#00A1E4",
        basePath: "client_branding/asset_living",
        stylingClass: css.assetLiving,
    },
    "0b1f3821-0616-4fed-9ca6-bfa9ecfd8f3c": {
        name: "assetLiving",
        colorPrimary: "#003C71",
        colorSecondary: "#00A1E4",
        basePath: "client_branding/asset_living",
        stylingClass: css.assetLiving,
    },
    "bc45dc34-1f7e-11ee-be56-0242ac120002": {
        name: "bella",
        colorPrimary: "#11396c",
        colorSecondary: "#11396c",
        basePath: "client_branding/bella",
        stylingClass: css.bella,
    },
    "9d2e54b0-8ae7-42c0-b514-f749738bd617": {
        name: "ti",
        colorPrimary: "#0a456e",
        colorSecondary: "#0a456e",
        basePath: "client_branding/ti",
        stylingClass: css.ti,
    },
    "51bd460e-19cf-11ee-be56-0242ac120002": {
        name: "haven",
        // You can't use "none" as a value in the color. The
        // renderer won't parse it. If you don't want a color,
        // use an rgba like so.
        colorPrimary: "rgba(0, 0, 0, 0)",
        colorSecondary: "#0f426b",
        basePath: "client_branding/haven",
        stylingClass: css.haven,
    },
    "ef9bdd4f-ec12-4d51-8b10-4db0ef498741": {
        name: "hff",
        colorPrimary: "#0f426b",
        colorSecondary: "transparent",
        basePath: "client_branding/hff",
        stylingClass: css.hff,
    },
    "70279817-eaaa-462c-bbeb-6b8489028c6e": {
        name: "Aldon",
        colorPrimary: "#21748a",
        colorSecondary: "#21748a",
        basePath: "client_branding/aldon",
        stylingClass: css.aldon,
    },
    "e97e70bb-44b9-45c6-bfa5-587140ebe833": {
        name: "DemoCorp",
        colorPrimary: "rgb(0, 105, 146)",
        colorSecondary: "rgb(163, 163, 164)",
        basePath: "client_branding/demo_corp9",
        stylingClass: css.demoCorp,
    },
    "7d73f64f-7ec4-4208-87f2-e9ddaf579236": {
        name: "nexmetro",
        colorPrimary: "#252435",
        colorSecondary: "#950F1C",
        basePath: "client_branding/nexmetro",
        stylingClass: css.nexmetro,
    },
    "beb361f0-9775-4e60-bf72-de7130b7d281": {
        name: "stout_proto",
        colorPrimary: "rgb(0, 48, 87)",
        colorSecondary: "rgb(229, 82, 3)",
        basePath: "client_branding/stout_proto",
        stylingClass: css.stoutproto,
    },
    "e0bceb4d-811a-4bc5-81a9-ffe8003a6b3f": {
        name: "valiant_proto",
        colorPrimary: "#124279",
        colorSecondary: "#3471B4",
        basePath: "client_branding/valiant_proto",
        stylingClass: css.valiantproto
    },
    "93659d88-9e7b-4eab-b2ea-c624cec99152": {
        name: "upf_proto",
        colorPrimary: "#204862",
        colorSecondary: "transparent",
        basePath: "client_branding/upf_proto",
        stylingClass: css.upfproto,
    },
    "cee52249-1d6b-4dc4-9d1c-9f535884b8d9": {
        name: "rushmore_proto",
        colorPrimary: "#233954",
        colorSecondary: "transparent",
        basePath: "client_branding/rushmore_proto",
        stylingClass: css.rushmoreproto,
    },
    "139e4403-ec2d-413d-a9c4-0564e60a0c68": {
        name: "link",
        colorPrimary: "black",
        colorSecondary: "rgb(253,219,0)",
        basePath: "client_branding/link",
        stylingClass: css.link,
    },
    "24c4eb3e-c038-4a90-9728-7934cb38bb42": {
        name: "avila_proto",
        colorPrimary: "#0D264A",
        colorSecondary: "#DDA93E",
        basePath: "client_branding/avila_proto",
        stylingClass: css.avilaproto,
    }
};

export const EXECUTIVE_SUMMARY_DEFAULT_PRIMARY_COLOR = "#083D41";
export const EXECUTIVE_SUMMARY_DEFAULT_SECONDARY_COLOR = "#888888";

export function loadClientBrandAsset(id?: string): IClientBrandingAssetBuilt {
    const defaultAsset: IClientBrandingAssetBuilt = {
        name: "default",
        colorPrimary: EXECUTIVE_SUMMARY_DEFAULT_PRIMARY_COLOR,
        colorSecondary: EXECUTIVE_SUMMARY_DEFAULT_SECONDARY_COLOR,
        basePath: "executive_summary",
        banner: "executive_summary/bg_img.jpg",
        logo: null,
        logoMini: null,
        showSignOffPage: false,
    };

    const clientAsset = CLIENT_LOGO_ASSET_MAP[id || ""];

    if (clientAsset) {
        return {
            ...clientAsset,
            banner: `${clientAsset.basePath}/bg_img.jpg`,
            logo: `/${clientAsset.basePath}/logo.png`,
            logoMini: `/${clientAsset.basePath}/logo_mini.png`,
        };
    }

    return defaultAsset;
}
